import { request, success, failure, LATE_COMING_REQUEST } from './utilities';
import { getLateComingList } from '../api';


export function getAllLateComing(data, token) {
    return (disapatch) => {
        disapatch(request(LATE_COMING_REQUEST.GET_LIST_REQUEST));
        getLateComingList(data, token).then(
            response => {
                if (response.data.status === 1) {
                    disapatch(success(LATE_COMING_REQUEST.GET_LIST_SUCCESS, response.data.data))
                }
                else {
                    disapatch(failure(LATE_COMING_REQUEST.GET_LIST_FAILURE, response.data.message))
                }
            },
            error => {
                disapatch(failure(LATE_COMING_REQUEST.GET_LIST_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}